import React, { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { Box, Text, Icon, VStack, HStack, Button, Image } from "@chakra-ui/react";
import { CheckCircleIcon, CloseIcon } from "@chakra-ui/icons";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { clearCallback } from "../../redux/transaction/action";
import { stringIsNullOrEmpty } from "common/util";

/// <summary>
/// Author: CK
/// </summary>
const Callback = () => {
  var _dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const isAuthorised = location.state;

  // Extract query parameters
  const status = searchParams.get("status"); // e.g., "Accepted" or "Failed"
  const transactionId = searchParams.get("transactionId");
  const callbackMessage = isAuthorised ? searchParams.get("errorMessage") : "Invalid Callback";
  const completionTime = searchParams.get("completionTime");
  const fiatAmount = searchParams.get("amount");
  const cryptoAmount = searchParams.get("cryptoAmount");
  const cryptocurrency = searchParams.get("cryptocurrency");

  // Determine if the status is success or failure
  const isSuccess = isAuthorised && status === "Accepted";

  /// <summary>
  /// Author: CK
  /// </summary>
  useEffect(() => {
    // Dismiss callback
    _dispatch(clearCallback());
  }, []);

  return (
    <div>
      <Box
        w="100%"
        h="100vh"
        display="flex"
        justifyContent="center"
        alignItems="center"
        bgGradient="linear(to-br, gray.50, gray.100)"
      >
        <VStack
          p={6}
          m={5}
          bg="white"
          boxShadow="lg"
          borderRadius="lg"
          maxW="lg"
          textAlign="center"
          w={'100%'}
          minH={'350px'}
          justifyContent="center"
        >
          {/* Icon based on status */}
          <Icon
            as={isSuccess ? CheckCircleIcon : CloseIcon}
            boxSize="50px"
            color={isSuccess ? "green.500" : "red.500"}
          />

          {/* Status Message */}
          <Text fontSize="2xl" fontWeight="bold" color="gray.700" mb={8}>
            {isSuccess ? "Transaction Successful" : "Transaction Failed"}
          </Text>

          {/* Fiat Amount */}
          {
            !stringIsNullOrEmpty(fiatAmount) &&
            <HStack spacing={2}>
              <Text fontSize="md" fontWeight="semibold" color="gray.600">
                Fiat Amount:
              </Text>
              <Text fontSize="md" color="gray.700">
                {fiatAmount} MYR
              </Text>
            </HStack>
          }

          {/* Crypto Amount */}
          {
            !stringIsNullOrEmpty(cryptoAmount) &&
            <HStack spacing={2}>
              <Text fontSize="md" fontWeight="semibold" color="gray.600">
                Crypto Amount:
              </Text>
              <Text fontSize="md" color="gray.700">
                {cryptoAmount} {cryptocurrency}
              </Text>
            </HStack>
          }

          {/* Callback Message */}
          <HStack spacing={2}>
            <Text fontSize="md" fontWeight="semibold" color="gray.600">
              Message:
            </Text>
            <Text fontSize="md" color="gray.700">
              {callbackMessage || "N/A"}
            </Text>
          </HStack>

          {
            isAuthorised && isSuccess ?
              <>
                {/* Completion Time */}
                <HStack spacing={2}>
                  <Text fontSize="md" fontWeight="semibold" color="gray.600">
                    Completed At:
                  </Text>
                  <Text fontSize="md" color="gray.700">
                    {completionTime || "N/A"}
                  </Text>
                </HStack>
              </>
              :
              <></>
          }
        </VStack>
      </Box>
    </div>
  );
};

export default Callback;
